module.exports = {

	googleMaps() {
		/* Google Maps API */
	   /* var map = document.createElement('script');
	    map.type = 'text/javascript';
	    map.async = true;
	    map.src = "https://maps.googleapis.com/maps/api/js?region=kr&client=gme-samsungsds&callback=MapLoaded&libraries=places,geometry";
*/
	    //document.getElementsByTagName("head")[0].appendChild(map);
	   // var scripts = document.getElementsByTagName('script')[0];
	    //console.log(scripts.src);
		//scripts.parentNode.insertBefore(map, scripts);

		console.debug('removing google script...');
	    let keywords = ['maps.googleapis'];

	    //Remove google from BOM (window object)
	    window.google = undefined;

	    //Remove google map scripts from DOM
	    let scripts = document.head.getElementsByTagName("script");
	    for (let i = scripts.length - 1; i >= 0; i--) {
	        let scriptSource = scripts[i].getAttribute('src');
	        if (scriptSource != null) {
	            if (keywords.filter(item => scriptSource.includes(item)).length) {
	                scripts[i].remove();
	            }
	        }
	    }


	    console.debug('adding google script...');
	    let googleMapApi = 'https://maps.googleapis.com/maps/api/js?region=kr&client=gme-samsungsds&callback=MapLoaded&libraries=places,geometry';
        let node = document.createElement('script');
        node.src = googleMapApi;
        node.type = 'text/javascript';
        node.async = false;
        node.charset = 'utf-8';
       // node.onload = uponFinishLoadingScript; //probably to initialise your map or something
        document.head.appendChild(node);




	},



    //var window;


	/*removeGoogleMapScript() {
	    console.debug('removing google script...');
	    let keywords = ['maps.googleapis'];

	    //Remove google from BOM (window object)
	    window.google = undefined;

	    //Remove google map scripts from DOM
	    let scripts = document.head.getElementsByTagName("script");
	    for (let i = scripts.length - 1; i >= 0; i--) {
	        let scriptSource = scripts[i].getAttribute('src');
	        if (scriptSource != null) {
	            if (keywords.filter(item => scriptSource.includes(item)).length) {
	                scripts[i].remove();
	                // scripts[i].parentNode.removeChild(scripts[i]);
	            }
	        }
	    }
	},


	addGoogleMapScript() {
	    this.removeGoogleMapScript();
	    console.debug('adding google script...');
	    let dynamicScripts = [`https://maps.googleapis.com/maps/api/js?region=kr&client=gme-samsungsds&callback=MapLoaded&libraries=places,geometry`];
	    for (let i = 0; i < dynamicScripts.length; i++) {
	        let node = document.createElement('script');
	        node.src = dynamicScripts[i];
	        node.type = 'text/javascript';
	        node.async = false;
	        node.charset = 'utf-8';
	        node.onload = uponFinishLoadingScript; //probably to initialise your map or something
	        document.head.appendChild(node);
	    }
	},*/

	getDaysArray(year, month) {
	    var numDaysInMonth, daysInWeek, daysIndex, index, i, l, daysArray;

	    numDaysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	    daysInWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	    daysIndex = { 'Sun': 0, 'Mon': 1, 'Tue': 2, 'Wed': 3, 'Thu': 4, 'Fri': 5, 'Sat': 6 };
	    index = daysIndex[(new Date(year, month - 1, 1)).toString().split(' ')[0]];
	    daysArray = [];

	    for (i = 0, l = numDaysInMonth[month - 1]; i < l; i++) {
	        daysArray.push((i + 1) + '. ' + daysInWeek[index++]);
	        if (index == 7) index = 0;
	    }

	    return daysArray;
	}

}